import React from "react";
import { Play, Pause, Volume2, VolumeX } from "lucide-react";
import { ASSETS, ARTIST, BG_TITLE } from "../data/worldData";

export default function AudioPlayer({ playing, onToggle, muted, onMute, volume, onVolume }) {
  return (
    <div
      data-testid="audio-player"
      className="fixed bottom-4 left-1/2 -translate-x-1/2 sm:left-4 sm:translate-x-0 z-[70] flex items-center gap-3 bg-[#15100E] text-[#ECE7DB] pl-2 pr-3 py-2 edge"
    >
      <img
        src={ASSETS.album}
        alt="now playing"
        className={`h-10 w-10 object-cover film ${playing ? "animate-spin-slow" : ""}`}
        style={{ borderRadius: "9999px" }}
      />
      <div className="hidden sm:block leading-tight max-w-[150px]">
        <p className="font-display font-bold text-sm truncate">{BG_TITLE}</p>
        <p className="font-tech text-[#CF9026] text-[9px] tracking-widest truncate">{ARTIST} · LIVE</p>
      </div>

      <button
        data-testid="audio-player-toggle"
        onClick={onToggle}
        className="h-9 w-9 bg-[#ECE7DB] text-[#15100E] flex items-center justify-center hover:bg-[#CF9026] transition-colors"
      >
        {playing ? <Pause size={16} fill="currentColor" /> : <Play size={16} fill="currentColor" className="ml-0.5" />}
      </button>
      <button data-testid="audio-mute-toggle" onClick={onMute} className="text-[#ECE7DB] hover:text-[#CF9026] transition-colors">
        {muted || volume === 0 ? <VolumeX size={17} /> : <Volume2 size={17} />}
      </button>
      <input
        data-testid="audio-volume"
        type="range" min="0" max="1" step="0.01"
        value={muted ? 0 : volume}
        onChange={(e) => onVolume(parseFloat(e.target.value))}
        className="hidden sm:block w-16 accent-[#CF9026] cursor-pointer"
      />
    </div>
  );
}
